import React from "react";
import { Link } from "react-router-dom";
import zainLogo from "../assets/img/zain-logo.svg";


function HomeNav() {
  return (
    <div>
      <nav className="navbar navbar-expand-lg header ">
        <div className="container-fluid d-flex justify-content-center">
          <Link to="/">
            <img src={zainLogo} alt="logo"/>
          </Link>
        </div>
      </nav>
    </div>
  );
}

export default HomeNav;
